/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').
    controller('WebSiteCureCategoryCtrl',["$scope","$rootScope","$routeParams","CureCategoryData",
    function($scope,$rootScope,$routeParams,CureCategoryData)
    {
        $scope.dd = {
            currentCategoryId :  parseInt($routeParams.categoryId)
        }
        $scope.redirectToHomeWhenAccessIsNotGranted();
        $scope.$watch('ad.dataLoaded', function(newValue, oldValue)
        {
            if (newValue)// && !$scope.ad.view.currentCategoryView)
            {
                var category = CureCategoryData.getById( $scope.dd.currentCategoryId);
                if (category)
                {
                    $scope.ad.msgErrorCategory = "";
                    $scope.setCurrentCureCategoryView($scope.ad.view.cureCategoryRootView.getCategoryView(category),false);
                }
                else
                {
                    $scope.ad.msgErrorCategory = "Nous sommes désolés mais cette catégorie n'existe plus.";
                }
            }
        });

    }
    ]);


// WEBPACK FOOTER //
// ./js/controllers/customerSite/WebSiteCureCategoryCtrl.js